const baseYear = '2024'
export function getCopyrightTime() {
    const currentYear = new Date().getFullYear();
    if (baseYear == currentYear) {
        return baseYear;
    }
    return baseYear + '-' + currentYear;
}
